import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Grid from "@mui/material/Grid";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,FormControlLabel,
    Checkbox
  } from "@mui/material";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import PowerIcon from "@mui/icons-material/Power";
import { WiStrongWind } from "react-icons/wi"; // visually resembles a sine wave
import cableDetails from "./Components/cableDetailsData.json"
import installationCondition from "./Components/installationCondition.json"
import deratingData from "./Components/deratingWizardOptions.json"
import additionalDeratingData from "./Components/additionalDeratingDetailsData.json"
import deratingImage from "./Components/Deratingimages.json"
import insulation_installation_mapping from "./Components/insulationmapping.json"
import cablesizeoption from "./Components/currentCarryingCapacityTable.json"

function InputComponent({ handleInputChange, inputDataSave }) {
  const [loadCurrent, setLoadCurrent] = useState("100");
  const [powerFactor, setPowerFactor] = useState("0.9");
  const [phase, setPhase] = useState("1 - Phase AC");
  const [supplyVoltage, setSupplyVoltage] = useState("230");
  const [maxVoltageDrop, setMaxVoltageDrop] = useState("5");
  const [lengthOfCable, setLengthOfCable] = useState("50");
  const [cableType, setCableType] = useState("TWO SINGLE-CORE");
  const [insulation, setInsulation] = useState("THERMOPLASTIC");
  const [conductor, setConductor] = useState("Copper solid/stranded");
  const [installationOption, setInstallationOption] = useState("Cables with minimum cable separation in air as shown and supported in vertical formation on ladders, racks, perforated trays, cleats or hanger");
  const [deratingConditions, setDeratingConditions] = useState({});
  const [additionalderatingConditions, setAdditionalDeratingConditions] = useState({});
  const [activeCableSizingMode, setActiveCableSizingMode] = useState("Automatic");
  const [selectedCircuit, setSelectedCircuit] = useState("1");
  const [selectedCableSize, setSelectedCableSize] = useState("1");
  const [earthCableSizingMode, setEarthCableSizingMode] = useState("Automatic");
  const [earthfaultlevel, setEarthFaultLevel] = useState("5");
  const [earthtriptime, setEarthTripTime] = useState("0.4");
  const [earthtripcurrent, setEarthTripCurrent] = useState("1500");
  const [activefaultlevel, setActiveFaultLevel] = useState("3");
  const [activetriptime, setActiveTripTime] = useState("5");
  const [earthconductor,setEarthConductor] = useState("Copper");
  const [rcdChecked, setRcdChecked] = useState(false);

  const backendinsulation = cableType && installationOption ? insulation_installation_mapping["Insulation"][insulation] || "" : "";
  const backendinstallation = cableType && installationOption ? insulation_installation_mapping["Installation"][cableType][installationOption] || "" : "";

  useEffect(() => {
    const inputData = {
      loadCurrent,
      powerFactor,
      phase,
      supplyVoltage,
      maxVoltageDrop,
      lengthOfCable,
      cableType,
      insulation,
      conductor,
      installationOption,
      deratingConditions,
      additionalderatingConditions,
      activeCableSizingMode,
      selectedCircuit,
      selectedCableSize,
      earthCableSizingMode,
      earthfaultlevel,
      earthtriptime,
      activefaultlevel,
      earthconductor,
      backendinstallation,
      backendinsulation,
      activetriptime,
      earthtripcurrent,
      rcdChecked
    };
      handleInputChange(inputData);
  }, [loadCurrent,powerFactor,phase,supplyVoltage,maxVoltageDrop,lengthOfCable,cableType,insulation,conductor,installationOption,deratingConditions,additionalderatingConditions,activeCableSizingMode,selectedCircuit,selectedCableSize,earthCableSizingMode,earthfaultlevel,earthtriptime,
      activefaultlevel,earthconductor,backendinstallation,backendinsulation,activetriptime,rcdChecked,earthtripcurrent]);





  

  const handlePhaseChange = (event) => {
    const selectedPhase = event.target.value;
    setPhase(selectedPhase);
  // Safely get options directly from the cableDetails object
    const cableOptions = Object.keys(cableDetails[selectedPhase] || {});
    const firstCable = cableOptions[0] || "";

    const insulationOpts = firstCable ? Object.keys(cableDetails[selectedPhase][firstCable] || {}) : [];
    const firstInsulation = insulationOpts[0] || "";

    const conductorOpts = (firstCable && firstInsulation)
        ? cableDetails[selectedPhase][firstCable][firstInsulation] || []
        : [];
    const firstConductor = conductorOpts[0] || "";

    switch (selectedPhase) {
      case '1 - Phase AC':
        setSupplyVoltage(230);
        setCableType(firstCable);
        setInsulation(firstInsulation);
        setConductor(firstConductor);
        break;
      case '3 - Phase AC':
        setSupplyVoltage(415);
        setCableType(firstCable);
        setInsulation(firstInsulation);
        setConductor(firstConductor);
        break;
      case '2 - Phase AC':
        setSupplyVoltage(480);
        setCableType(firstCable);
        setInsulation(firstInsulation);
        setConductor(firstConductor);
        break;
      case 'DC':
        setSupplyVoltage(230);
        setCableType(firstCable);
        setInsulation(firstInsulation);
        setConductor(firstConductor);
        break;
      default:
        setSupplyVoltage(""); // Or keep previous / fallback
    }
  };

  const handleCableTypeChange = (event) => {
    setCableType(event.target.value);
  };

  const handleInsulationTypeChange = (event) => {
    setInsulation(event.target.value);
  };

  const handleConductorChange = (event) => {
    setConductor(event.target.value);
  };

  const cableTypeOptions = phase ? Object.keys(cableDetails[phase] || {}) : [];
  const insulationOptions = phase && cableType ? Object.keys(cableDetails[phase][cableType] || {}) : [];
  const conductorOptions = phase && cableType && insulation ? cableDetails[phase][cableType][insulation] || [] : [];
  const installOptions = cableType ? Object.entries(installationCondition[cableType] || {}).map(
      ([type, imgPath]) => ({ type, imgPath })
    )
  : [];

  const deratingOptions = cableType && installationOption ? deratingData[cableType][installationOption] || [] : [];
  const additionalDeratingOptions = cableType && installationOption && additionalDeratingData[cableType][installationOption] && additionalDeratingData[cableType][installationOption][deratingConditions["Installation"]] ? additionalDeratingData[cableType][installationOption][deratingConditions["Installation"]] || [] : [];
  const installationImage = cableType && installationOption ? deratingImage[cableType][deratingConditions["Installation"]] || deratingImage[cableType][installationOption] : "";

const avtivecablesizeoption = cableType && installationOption && backendinsulation 
  ? Object.entries(
      cablesizeoption?.[cableType]?.[backendinsulation]?.[conductor]?.[backendinstallation] || {}
    ).sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]))
  : [];
const numberofcircuit = [1,2,3,4,5,6,7,8,9,10]



useEffect(() => {
  if (inputDataSave.selectedCableSize === undefined) {
  if (avtivecablesizeoption.length > 0 && Array.isArray(avtivecablesizeoption[0])) {
    setSelectedCableSize(avtivecablesizeoption[0][0]);
  }}
}, [backendinstallation, cableType, insulation, conductor,backendinsulation]);

useEffect(() => {
  if (inputDataSave.installationOption === undefined) {
setInstallationOption(installOptions[0]["type"]);}
}, [cableType]);




const getInitialAdditionalDeratingValues = (options) => {
    const initialValues = {};
    options.forEach((option) => {
        Object.entries(option).forEach(([label, values]) => {
            if (values.length > 0) {
                initialValues[label] = values[0];
            }
        });
    });
    return initialValues;
};
useEffect(() => {
  if (inputDataSave.installationOption === undefined) {
    if (additionalDeratingOptions.length > 0) {
        const initialValues = getInitialAdditionalDeratingValues(additionalDeratingOptions);
        setAdditionalDeratingConditions(initialValues);
    }}
}, [deratingConditions]);

const getInitialDeratingValues = (options) => {
    const initialValues = {};
    options.forEach((option) => {
        Object.entries(option).forEach(([label, values]) => {
            if (values.length > 0) {
                initialValues[label] = values[0];
            }
        });
    });
    return initialValues;
};
useEffect(() => {
  if (inputDataSave.deratingConditions === undefined) {
    if (deratingOptions.length > 0) {
        const initialValues = getInitialDeratingValues(deratingOptions);
        setDeratingConditions(initialValues);
    }}
}, [deratingOptions]);


useEffect(() => {
  if (inputDataSave.additionalderatingConditions === undefined) {
setAdditionalDeratingConditions({})}
}, [installationOption]);



const hasMatchingKeys = (options, conditions) => {
    const optionKeys = options.flatMap(option => Object.keys(option));
    const conditionKeys = Object.keys(conditions);
    return optionKeys.every(key => conditionKeys.includes(key));
};

useEffect(() => {
  if (inputDataSave.loadCurrent !== undefined) setLoadCurrent(inputDataSave.loadCurrent);
  if (inputDataSave.powerFactor !== undefined) setPowerFactor(inputDataSave.powerFactor);
  if (inputDataSave.phase !== undefined) setPhase(inputDataSave.phase);
  if (inputDataSave.supplyVoltage !== undefined) setSupplyVoltage(inputDataSave.supplyVoltage);
  if (inputDataSave.maxVoltageDrop !== undefined) setMaxVoltageDrop(inputDataSave.maxVoltageDrop);
  if (inputDataSave.lengthOfCable !== undefined) setLengthOfCable(inputDataSave.lengthOfCable);
  if (inputDataSave.cableType !== undefined) setCableType(inputDataSave.cableType);
  if (inputDataSave.insulation !== undefined) setInsulation(inputDataSave.insulation);
  if (inputDataSave.conductor !== undefined) setConductor(inputDataSave.conductor);
  if (inputDataSave.installationOption !== undefined) setInstallationOption(inputDataSave.installationOption);
  if (inputDataSave.deratingConditions !== undefined) setDeratingConditions(inputDataSave.deratingConditions);
  if (inputDataSave.additionalderatingConditions !== undefined) setAdditionalDeratingConditions(inputDataSave.additionalderatingConditions);
  if (inputDataSave.activeCableSizingMode !== undefined) setActiveCableSizingMode(inputDataSave.activeCableSizingMode);
  if (inputDataSave.selectedCircuit !== undefined) setSelectedCircuit(inputDataSave.selectedCircuit);
  if (inputDataSave.selectedCableSize !== undefined) setSelectedCableSize(inputDataSave.selectedCableSize);
  if (inputDataSave.earthCableSizingMode !== undefined) setEarthCableSizingMode(inputDataSave.earthCableSizingMode);
  if (inputDataSave.earthfaultlevel !== undefined) setEarthFaultLevel(inputDataSave.earthfaultlevel);
  if (inputDataSave.earthtriptime !== undefined) setEarthTripTime(inputDataSave.earthtriptime);
  if (inputDataSave.activefaultlevel !== undefined) setActiveFaultLevel(inputDataSave.activefaultlevel);
  if (inputDataSave.earthconductor !== undefined) setEarthConductor(inputDataSave.earthconductor);
  if (inputDataSave.activetriptime !== undefined) setActiveTripTime(inputDataSave.activetriptime);
  if (inputDataSave.earthtripcurrent !== undefined) setEarthTripCurrent(inputDataSave.earthtripcurrent);
  if (inputDataSave.rcdChecked !== undefined) setRcdChecked(inputDataSave.rcdChecked);
  console.log("loadCurrent",inputDataSave)

}, [inputDataSave]);


  return (
    <div className="App">
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh" }}
      >
        <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                LOAD DETAILS
              </Typography>
            </Stack>

            <Box component="form" noValidate autoComplete="off">
              <TextField
                label="Load Current (A)"
                variant="outlined"
                fullWidth
                margin="normal"
                type="number"
                value={loadCurrent}
                onChange={(e) => setLoadCurrent(e.target.value)}
                InputProps={{
                  style: { fontSize: "1.1rem",
                    fontFamily: "'Hubballi', sans-serif",
                   },
                   
                }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />

              <TextField
                label="Power Factor"
                variant="outlined"
                type="number"
                fullWidth
                margin="normal"
                value={powerFactor}
  onChange={(e) => {
    const val = parseFloat(e.target.value);
    if (val >= 0 && val <= 1) {
      setPowerFactor(e.target.value);
    } else if (e.target.value === "") {
      setPowerFactor(""); // allow clearing the field
    }
  }}
                  inputProps={{
    min: 0,
    max: 1,
    step: 0.01,
  }}
                InputProps={{
                    style: { fontSize: "1.1rem",
                      fontFamily: "'Hubballi', sans-serif",
                     },
                     
                  }}

                InputLabelProps={{
                    style: {
                      fontFamily: "'Hubballi', sans-serif",
                      fontSize: "1.1rem",
                    },
                  }}
              />
            </Box>
          </Paper>
        </Grid>


 <Grid item xs={11} sm={11} md={4}>
  <Paper
    elevation={6}
    style={{
      padding: "2.5rem",
      borderRadius: "20px",
      background: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
        }}
      >
        SUPPLY DETAILS
      </Typography>
    </Stack>

    <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
      {/* Phase dropdown - full width */}
      <FormControl fullWidth margin="normal">
        <InputLabel
          id="phase-label"
          style={{
            fontFamily: "'Hubballi', sans-serif",
            fontSize: "1.1rem",
          }}
        >
          Phase
        </InputLabel>
        <Select
          labelId="phase-label"
          value={phase}
          onChange={handlePhaseChange}
          label="Phase"
          variant="outlined"
          style={{
            fontFamily: "'Hubballi', sans-serif",
            fontSize: "1.1rem",
          }}
        >
          <MenuItem value="1 - Phase AC" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>1 - Phase AC</MenuItem>
          {/* <MenuItem value="2 - Phase AC" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>2 - Phase AC</MenuItem> */}
          <MenuItem value="3 - Phase AC" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>3 - Phase AC</MenuItem>
          <MenuItem value="DC" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>DC</MenuItem>
        </Select>
      </FormControl>
</Grid>
      {/* First Row: Line Voltage & Max Voltage Drop */}
  
        <Grid item xs={6} sm={6}>
          <TextField
            label="Line Voltage (V)"
            variant="outlined"
            type="number"
            fullWidth
            margin="normal"
            value={supplyVoltage}
            onChange={(e) => setSupplyVoltage(e.target.value)}
            InputProps={{
              style: {
                fontSize: "1.1rem",
                fontFamily: "'Hubballi', sans-serif",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "'Hubballi', sans-serif",
                fontSize: "1.1rem",
              },
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6}>
          <TextField
            label="Max Voltage Drop (%)"
            variant="outlined"
            type="number"
            fullWidth
            margin="normal"
            value={maxVoltageDrop}
            onChange={(e) => setMaxVoltageDrop(e.target.value)}
            InputProps={{
              style: {
                fontSize: "1.1rem",
                fontFamily: "'Hubballi', sans-serif",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "'Hubballi', sans-serif",
                fontSize: "1.1rem",
              },
            }}
          />
        </Grid>
                <Grid item xs={6} sm={6}>
          <TextField
            label="Length of Cable (m)"
            variant="outlined"
            fullWidth
            margin="normal"
            type="number"
            value={lengthOfCable}
            onChange={(e) => setLengthOfCable(e.target.value)}
            InputProps={{
              style: {
                fontSize: "1.1rem",
                fontFamily: "'Hubballi', sans-serif",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "'Hubballi', sans-serif",
                fontSize: "1.1rem",
              },
            }}
          />
        </Grid>
                <Grid item xs={6} sm={6}>
          <TextField
            label="Fault Level (kA)"
            variant="outlined"
            fullWidth
            margin="normal"
            type="number"
            value={activefaultlevel}
            onChange={(e) => setActiveFaultLevel(e.target.value)}
            InputProps={{
              style: {
                fontSize: "1.1rem",
                fontFamily: "'Hubballi', sans-serif",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "'Hubballi', sans-serif",
                fontSize: "1.1rem",
              },
            }}
          />
        </Grid>



                        <Grid item xs={6} sm={6}>
          <TextField
            label="Short Circuit Duration (s)"
            variant="outlined"
            fullWidth
            margin="normal"
            type="number"
            value={activetriptime}
            onChange={(e) => setActiveTripTime(e.target.value)}
            InputProps={{
              style: {
                fontSize: "1.1rem",
                fontFamily: "'Hubballi', sans-serif",
              },
            }}
            InputLabelProps={{
              style: {
                fontFamily: "'Hubballi', sans-serif",
                fontSize: "1.1rem",
              },
            }}
          />
        </Grid>


      </Grid>

      {/* Second Row: Length of Cable (single input full width for balance) */}
     

      
    </Box>
  </Paper>
</Grid>




        
        <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                CABLE DETAILS
              </Typography>
            </Stack>

            <Box component="form" noValidate autoComplete="off">
            <FormControl fullWidth margin="normal">
                <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Cable Type</InputLabel>
                <Select
                    value={cableType}
                    onChange={handleCableTypeChange}
                    label="Cable Type"
                    sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                >
                    {cableTypeOptions.map((type) => (
                    <MenuItem key={type} value={type} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        {type}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>


<FormControl fullWidth margin="normal">
                <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Insulation</InputLabel>
                <Select
                    value={insulation}
                    onChange={handleInsulationTypeChange}
                    label="Insulation"
                    sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                >
                    {insulationOptions.map((type) => (
                    <MenuItem key={type} value={type} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        {type}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>


                <FormControl fullWidth margin="normal">
                <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>Conductor</InputLabel>
                <Select
                    value={conductor}
                    onChange={handleConductorChange}
                    label="Conductor"
                    sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                >
                    {conductorOptions.map((type) => (
                    <MenuItem key={type} value={type} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        {type}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>

            </Box>
          </Paper>
        </Grid>

        
        <Grid item xs={11} sm={11} md={4}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                INSTALLATION DETAILS
              </Typography>
            </Stack>

            <Box component="form" noValidate autoComplete="off">

            </Box>

            <Box component="form" noValidate autoComplete="off">
            <FormControl fullWidth margin="normal" label="Installation Method">
            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                Installation Method
            </InputLabel>
            <Select
                value={installationOption}
                onChange={(e) => setInstallationOption(e.target.value)}
                label="Installation Methods"
                sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            maxWidth: "300px", // Set a max width to control the overall popup size
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "normal",
                        },
                    },
                }}
            >
                {installOptions.map(({ type, imgPath }) => (
                <MenuItem key={type} value={type}>
                    <Box display="flex" alignItems="center" gap={2}>

                    <Typography sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem",                                whiteSpace: "normal", 
                                wordWrap: "break-word", 
                                overflowWrap: "break-word" }}>
                        {type}
                    </Typography>
                    <img
                        src={imgPath[0]}
                        alt={type}
                        width={100}
                        height={100}
                        style={{ objectFit: "contain", borderRadius: "4px" }}
                    />
                    </Box>
                </MenuItem>

                
                ))}
            </Select>
            </FormControl>

            {installationOption && (
        (() => {
            const reference = installOptions.find((opt) => opt.type === installationOption)?.imgPath[1] || "";
            return reference.trim() ? (
                <Box
                    mt={2}
                    p={2}
                    sx={{
                        background: "#f9f9f9",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Hubballi', sans-serif",
                            fontSize: "1rem",
                            fontWeight: "550",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                        }}
                    >
                        Installation Reference:
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "'Hubballi', sans-serif",
                            fontSize: "0.9rem",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            color: "#555",
                        }}
                    >
                        {reference} ({backendinstallation})
                    </Typography>
                </Box>
            ) : null;
        })()
    )}


            </Box>
          </Paper>
        </Grid>


<Grid item xs={11} sm={11} md={4}>
  <Paper
    elevation={6}
    style={{
      padding: "2.5rem",
      borderRadius: "20px",
      background: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
        }}
      >
        DERATING WIZARD
      </Typography>
    </Stack>

    {/* Internal Two-Column Layout */}
    <Grid container spacing={2}>
      {/* Inputs */}
      <Grid item xs={12} md={8}>
        {hasMatchingKeys(deratingOptions, deratingConditions) &&
          deratingOptions.map((option, index) =>
            Object.entries(option).map(([label, values], i) => (
              <FormControl fullWidth margin="normal" key={`${index}-${i}`}>
                <InputLabel
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {label}
                </InputLabel>
                <Select
                  value={deratingConditions[label]}
                  onChange={(e) =>
                    setDeratingConditions((prev) => ({
                      ...prev,
                      [label]: e.target.value,
                    }))
                  }
                  label={label}
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {values.map((value, j) => (
                    <MenuItem
                      key={j}
                      value={value}
                      sx={{
                        fontFamily: "'Hubballi', sans-serif",
                        fontSize: "1.1rem",
                      }}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))
          )}

        {hasMatchingKeys(
          additionalDeratingOptions,
          additionalderatingConditions
        ) &&
          additionalDeratingOptions.map((option, index) =>
            Object.entries(option).map(([label, values], i) => (
              <FormControl fullWidth margin="normal" key={`${index}-${i}`}>
                <InputLabel
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {label}
                </InputLabel>
                <Select
                  value={additionalderatingConditions[label]}
                  onChange={(e) =>
                    setAdditionalDeratingConditions((prev) => ({
                      ...prev,
                      [label]: e.target.value,
                    }))
                  }
                  label={label}
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "1.1rem",
                  }}
                >
                  {values.map((value, j) => (
                    <MenuItem
                      key={j}
                      value={value}
                      sx={{
                        fontFamily: "'Hubballi', sans-serif",
                        fontSize: "1.1rem",
                      }}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))
          )}
      </Grid>

      {/* Image */}
      {installationImage && (
        <Grid item xs={12} md={4} display="flex" justifyContent="center" alignItems="center">
          <img
            src={installationImage}
            alt=""
            width={150}
            height={150}
            style={{ objectFit: "contain", borderRadius: "4px" }}
          />
        </Grid>
      )}
    </Grid>
  </Paper>
</Grid>

      
<Grid item xs={11} sm={11} md={4}>
  <Paper
    elevation={6}
    style={{
      padding: "2.5rem",
      borderRadius: "20px",
      background: "#ffffff",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
        }}
      >
        ACTIVE CABLE SIZING
      </Typography>
    </Stack>

    <Box component="form" noValidate autoComplete="off">


      {/* Active Cable Sizing Dropdown */}
      <FormControl fullWidth margin="normal">
        <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
          Active Cable Sizing
        </InputLabel>
        <Select
          value={activeCableSizingMode}
          onChange={(e) => setActiveCableSizingMode(e.target.value)}
          label="Active Cable Sizing"
          sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
        >
          <MenuItem value="Automatic" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            Automatic
          </MenuItem>
          <MenuItem value="User Selection" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            User Selection
          </MenuItem>
        </Select>
      </FormControl>

      {activeCableSizingMode === "User Selection" && (
        <>


          {/* Show circuit x cable size side-by-side with '×' once circuit is selected */}
          {selectedCircuit && (
            <Grid container spacing={2} alignItems="center">
              {/* Circuits Input (readonly) - 3 columns out of 12 (1/4) */}
              <Grid item xs={3}>
          {/* Number of Circuits Dropdown */}
          <FormControl fullWidth margin="normal">
            <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
              No of Circuits
            </InputLabel>
            <Select
              value={selectedCircuit}
              onChange={(e) => setSelectedCircuit(e.target.value)}
              label="No of Circuits"
              sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
            >
              {numberofcircuit.map((num) => (
                <MenuItem key={num} value={num} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                  {num}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
              </Grid>

              {/* × symbol - 1 column out of 12 */}
              <Grid item xs={1} sx={{ textAlign: "center", fontSize: "2rem", fontWeight: "",fontFamily: "'Hubballi', sans-serif" }}>
                ×
              </Grid>

              {/* Cable Size Dropdown - 8 columns out of 12 (2/3) */}
              <Grid item xs={8}>
                <FormControl fullWidth>
                  <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                    Cable Size (mm2)
                  </InputLabel>
                  <Select
                    value={selectedCableSize}
                    onChange={(e) => setSelectedCableSize(e.target.value)}
                    label="Cable Size (mm2)"
                    sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
                  >
                    {avtivecablesizeoption.map(([size, _]) => (
                      <MenuItem key={size} value={size} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}
        </>
      )}

         <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          fontWeight: "700",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
          paddingTop: "20px",
        }}
      >
        EARTH CABLE SIZING
      </Typography>      
    </Stack>

              <FormControl fullWidth margin="normal">
        <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
          Protective Earth Conductor Material
        </InputLabel>
        <Select
          value={earthconductor}
          onChange={(e) => setEarthConductor(e.target.value)}
          label="Protective Earth Conductor Material"
          sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
        >
          <MenuItem value="Copper" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
           Copper
          </MenuItem>
          <MenuItem value="Aluminium" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
           Aluminium
          </MenuItem>
        </Select>
      </FormControl>

          <FormControl fullWidth margin="normal">
        <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
          Earth Cable Sizing 
        </InputLabel>
        <Select
          value={earthCableSizingMode}
          onChange={(e) => setEarthCableSizingMode(e.target.value)}
          label="Active Cable Sizing"
          sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
        >
          <MenuItem value="Automatic" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
           AS/NZS 3000:2018, Table 5.1 
          </MenuItem>
          <MenuItem value="calculation" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
           AS/NZS 3000:2018, Section B4.4 (Line-Ground Fault level known)
          </MenuItem>
                    {/* <MenuItem value="approximation" sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
           AS/NZS 3000:2018, Section B4.4 (Line-Ground Fault level not known)
          </MenuItem> */}
        </Select>
      </FormControl>

{earthCableSizingMode !== "Automatic" && (

 
  <Grid container spacing={2} alignItems="center">
  {earthCableSizingMode !== "approximation" ? (
    <>
      {/* Line-Ground Fault Level (kA) - numeric input */}
      <Grid item xs={6}>
        <TextField
          label="Line-Ground Fault Level (kA)"
          type="number"
          value={earthfaultlevel}
          onChange={(e) => setEarthFaultLevel(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            style: { fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" },
          }}
          InputLabelProps={{
            style: { fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" },
          }}
        />
      </Grid>
    </>
  ) : (
    <Grid item xs={6}>
      <Box
        mt={2}
        p={2}
        sx={{
          background: "#f9f9f9",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <Typography
          sx={{
            fontFamily: "'Hubballi', sans-serif",
            fontSize: "1rem",
            fontWeight: "550",
          }}
        >
          Note:
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Hubballi', sans-serif",
            fontSize: "0.9rem",
            color: "#555",
          }}
        >
          It is assumed that there will always be 80% or more of the nominal
          phase voltage available at the position of the circuit protective
          device.
        </Typography>
      </Box>
    </Grid>
  )}
    

    {/* Instantaneous Trip Time (s) - dropdown */}
    <Grid item xs={6}>
      <FormControl fullWidth margin="normal">
        <InputLabel sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
          Instantaneous Trip Time (s)
        </InputLabel>
        <Select
          value={earthtriptime}
          onChange={(e) => setEarthTripTime(e.target.value)}
          label="Instantaneous Trip Time (s)"
          sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}
        >
          <MenuItem value={0.4} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            0.4
          </MenuItem>
          <MenuItem value={5} sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" }}>
            5
          </MenuItem>
        </Select>
      </FormControl>
    </Grid>


      <Grid item xs={6}>
        <TextField
          label="Protective Device Instantaneous Trip (A)"
          type="number"
          value={earthtripcurrent}
          onChange={(e) => setEarthTripCurrent(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            style: { fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" },
          }}
          InputLabelProps={{
            style: { fontFamily: "'Hubballi', sans-serif", fontSize: "1.1rem" },
          }}
        />
      </Grid>


<Grid item xs={6}>
  <FormControlLabel
    control={
      <Checkbox
        checked={rcdChecked}
        onChange={(e) => setRcdChecked(e.target.checked)}
        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
      />
    }
    label={
      <Typography sx={{ fontFamily: "'Hubballi', sans-serif", fontSize: '1.1rem' }}>
        RCD Installed
      </Typography>
    }
    sx={{ mt: 2 }}
  />
</Grid>

    
  </Grid>
)}
    </Box>
  </Paper>
</Grid>


























      </Grid>
    </div>
  );
}

export default InputComponent;
